import { render } from "./LogoImg.vue?vue&type=template&id=7e90f248&scoped=true"
import script from "./LogoImg.vue?vue&type=script&lang=ts"
export * from "./LogoImg.vue?vue&type=script&lang=ts"

import "./LogoImg.vue?vue&type=style&index=0&id=7e90f248&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e90f248"

export default script